import {
  Image,
  StyleSheet,
  Text,
  View,
  ViewStyle,
  TouchableOpacity,
  StyleProp,
  ImageStyle,
  TextStyle,
  ColorValue,
} from "react-native";
import React, { FC } from "react";
import { ParamListBase, useNavigation } from "@react-navigation/native";
import { ImageSourcePropType } from "react-native/Libraries/Image/Image";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import DebounceButton from "../../screen/DebounceButton";
import ArrawIcon from "../../assets/svg/ic_left_arrow.svg";
import { color_666666 } from "../../assets/style/colors";

export interface NavBarProps {
  style?: ViewStyle;
  title?: string;
  backIcon?: ImageSourcePropType;
  tintColor?: string;
  backIconStyle?: StyleProp<ImageStyle>;
  titleStyle?: TextStyle;
  titleView?: React.ReactNode;
  rightChildren?: React.ReactNode;
  backClick?: () => void;
  rightClick?: () => void;
  showBack?: boolean;
}

function NavBar(props: NavBarProps) {
  let navigation = useNavigation<NativeStackNavigationProp<ParamListBase>>();
  return (
    <View style={[styles.container, props.style]}>
      <View
        style={{
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          start: 0,
          width: "100%",
        }}
      >
        {props.titleView ? (
          props.titleView
        ) : (
          <Text
            numberOfLines={1}
            ellipsizeMode={"tail"}
            style={[styles.title, props.titleStyle]}
          >
            {props.title}
          </Text>
        )}
      </View>
      {props.showBack && (
        <TouchableOpacity
          activeOpacity={1}
          onPress={() => {
            props.backClick ? props.backClick() : navigation.goBack();
          }}
          style={[styles.leftComponent]}
        >
          {props.backIcon ? (
            <Image
              style={props.backIconStyle}
              tintColor={props.tintColor}
              source={props.backIcon}
            />
          ) : (
            <ArrawIcon fill={props.tintColor || color_666666} />
          )}
        </TouchableOpacity>
      )}
      {!props.showBack && <View style={[styles.leftComponent]} />}
      <DebounceButton
        // <TouchableOpacity
        activeOpacity={1}
        debounceTime={2000}
        onPress={props.rightClick}
        style={styles.rightComponent}
      >
        {props.rightChildren}
      </DebounceButton>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 44,
    backgroundColor: "rgba(255,255,255,255)",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  leftComponent: {
    alignItems: "center",
    justifyContent: "center",
    width: 44,
    height: "100%",
  },
  rightComponent: {
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    height: "100%",
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    color: "black",
    overflow: "hidden",
    fontFamily: "",
    width: "60%",
    textAlign: "center",
  },
});

export default NavBar;
